import { Grid } from "@chakra-ui/react";
import React from "react";
import { GridProps } from "../../utils/types/props.grid";

const AppGrid = ({ columns, children, gap, style }: GridProps) => {
  return (
    <Grid style={style} templateColumns={columns} gap={gap}>
      {children}
    </Grid>
  );
};

export default AppGrid;
